import script from "./Parameters.vue?vue&type=script&setup=true&lang=js"
export * from "./Parameters.vue?vue&type=script&setup=true&lang=js"

import "./Parameters.vue?vue&type=style&index=0&id=7ecaa984&lang=css"

const __exports__ = script;

export default __exports__